import { APPLICATION_STATE } from "entities/application/constants";
import { useSelector } from "react-redux";
import { RootState } from "store";

export const useIsCalculatingRoutes = () => {
  const routeCalculationStatus = useSelector(
    (state: RootState) => state[APPLICATION_STATE].routeCalculationLoadingStatus
  );

  return routeCalculationStatus !== "" && routeCalculationStatus !== "done";
};

export const useCalculatingRoutesStatus = () => {
  const routeCalculationStatus = useSelector(
    (state: RootState) => state[APPLICATION_STATE].routeCalculationLoadingStatus
  );

  return routeCalculationStatus;
};
